import React from "react";
import { useNavigate } from "react-router-dom";

function DocumentCard({
  id,
  name,
  image,
  linkType = "page",
  link,
  wide = false,
  imgClass = undefined,
  cardClass = undefined,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (linkType === "page") {
      navigate(link);
    } else if (linkType === "file") {
      window.open(link, "_blank");
    }
  };

  const defaultCardClass = "bg-white shadow-md";
  const defaultImgClass = "object-fit h-36";

  return (
    <div
      className={`rounded-xl overflow-hidden cursor-pointer transition-transform duration-200 ${
        wide ? "w-96" : "w-56"
      } m-4 flex flex-col items-center hover:scale-105 ${
        cardClass ? cardClass : defaultCardClass
      }`}
      onClick={handleClick}
    >
      <img
        src={image}
        alt={name}
        className={`w-full ${wide ? "h-32" : ""} ${
          imgClass ? imgClass : defaultImgClass
        }`}
      />
      <div className="p-3 text-lg font-semibold text-center">{name}</div>
    </div>
  );
}

export default DocumentCard;
